import PaymentWallet from "./PaymentWallet";

export default PaymentWallet;
